export const ARTIST = [
  {
    id: "artist_boomboxcartel",
    type: "djs",
    title: "Boombox Cartel",
    artistLink: "boxcar", /* link */
    featured: true,
    playlistBg: "#627255",
    imgUrl: "/image/djs/boombox-cartel/boombox-cartel.jpg",
    hoverColor: "#627255",
    artist: "boomboxcartel", /* ex artist */
    redSocial: "https://instagram.com",
    telefono: "+34602316998",
    artistImgUrl: "../image/djs/boombox-cartel/boombox-cartel.jpg",
    artistBio: "Boom 💥",
    pistaRecomendada: 0,
    artistartistDownloadBio: "Descargar",
    club: "LA. CLub",
    clubtime: "2024-12-11T04:30",
    endtime: "2024-12-12T02:00",
    clubmapa: "Los Angeles EEUU",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistImages: [
      "../image/djs/boombox-cartel/01/taking-over.jpg",
      "../image/djs/boombox-cartel/01/jellyfish-jam.jpg",
      "../image/djs/boombox-cartel/01/any-other-way.jpg",
      "../image/djs/boombox-cartel/01/dancing-with-fire.jpg"
    ],
    recomendacion: [
      "../image/djs/boombox-cartel/01/taking-over.jpg",
      "../image/djs/boombox-cartel/01/taking-over.jpg",
      "../image/djs/boombox-cartel/01/taking-over.jpg"
    ],
    playlistData: [
      {
        id: "1",
        trackId: "bombox",
        songName: "🅴 TAKING OVER",
        songimg: "../image/djs/boombox-cartel/01/taking-over.jpg",
        songArtist: "Bombox Cartel",
        link: "https://dl.dropbox.com/s/nokuxvpxr75bzni/BOX%20CAR%20-%20TAKING%20OVER.mp3",
        trackTime: "4:19"
      },
      {
        id: "2",
        trackId: "bombox2",
        videoUrl: "../image/djs/boombox-cartel/01/blue.mp4",
        songName: "JELLYFISH JAM",
        songimg: "../image/djs/boombox-cartel/01/jellyfish-jam.jpg",
        songArtist: "Bombox Cartel",
        link: "https://dl.dropbox.com/s/m0356hu0tt31nf8/BOX%20CAR%20-%20JELLYFISH%20JAM.mp3",
        trackTime: "3:11"
      },
      {
        id: "3",
        songName: "ANY OTHER WAY",
        songimg: "../image/djs/boombox-cartel/01/any-other-way.jpg",
        songArtist: "Bombox Cartel",
        link: "https://dl.dropbox.com/s/nuhpmwb24ddt0tg/BOX%20CAR%20-%20ANY%20OTHER%20WAY.mp3",
        trackTime: "5:58"
      },
      {
        id: "4",
        songName: "Dancing With Fire",
        songimg: "../image/djs/boombox-cartel/01/dancing-with-fire.jpg",
        songArtist: "Bombox Cartel ft. Stalking Gia",
        link: "https://dl.dropbox.com/s/3febkyk0c3j6omz/Boombox%20Cartel%20-%20Dancing%20With%20Fire%20%28feat.%20Stalking%20Gia%29.mp3",
        trackTime: "3:51"
      }
    ]
  },
  {
    id: "artist_alibhtty",
    type: "djs",
    title: "Ali Bhtty",
    artistLink: "alibhtty",
    featured: true,
    playlistBg: "rgb(103, 188, 224)",
    imgUrl: "/image/djs/alibhtty/alibhtty.jpg",
    hoverColor: "rgb(103, 188, 224)",
    artist: "alibhtty",
    redSocial: "https://instagram.com/ali.bhtty/",
    telefono: "+34602316998",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "MUSIC4EVER 👾",
    pistaRecomendada: 1,
    artistartistDownloadBio: "Descargar",
    club: "Rei de Copes",
    clubtime: "2026-08-03T09:10",
    endtime: "2026-08-03T12:50",
    clubmapa: "Gran Vía de les Corts Catalanes 1080",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "../image/djs/alibhtty/list.jpg",
    downloadData: [
      {
        id: "1",
        songName: "Ep.013 Cy-BORED – ID",
        songimg: "../image/set/radioshow/013.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.013-Cy-bored-Ali-Bhtty.m4a",
        trackTime: "14:55"
      }
    ],
    playlistImages: [
      "../image/djs/alibhtty/feed/01.jpg",
      "../image/djs/alibhtty/feed/02.jpg",
      "../image/djs/alibhtty/feed/03.jpg"
    ],
    recomendacion: [
      "../image/djs/alibhtty/recom/rec-01.jpg",
      "../image/djs/alibhtty/recom/rec-02.jpg",
      "../image/djs/alibhtty/recom/rec-03.jpg",
      "../image/djs/alibhtty/recom/rec-04.jpg"
    ],
    playlistData: [
      {
        id: "1",
        songName: "Ep.015 House Sauce",
        songimg: "../image/set/radioshow/015.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.015-House-Sause-Ali-Bhtty.m4a",
        trackTime: "16:00"
      },
      {
        id: "2",
        songName: "Ep.014 BCN City Vibes",
        songimg: "../image/set/radioshow/014.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.014-BCN-City-Vibes-Ali-Bhtty.m4a",
        trackTime: "16:31"
      },
      {
        id: "3",
        songName: "Ep.013 Cy-BORED",
        songimg: "../image/set/radioshow/013.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.013-Cy-bored-Ali-Bhtty.m4a",
        trackTime: "14:55"
      },
      {
        id: "4",
        songName: "Ep.012 Turn It Up",
        songimg: "../image/set/radioshow/012.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.012-Turn-It-Up-Ali-Bhtty.m4a",
        trackTime: "16:34"
      },
      {
        id: "5",
        songName: "Ep.011 Blackouts",
        songimg: "../image/set/radioshow/011.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.011-Blackouts-Ali-Bhtty.m4a",
        trackTime: "19:09"
      },
      {
        id: "6",
        songName: "Ep.010 Wild Therapy",
        songimg: "../image/set/radioshow/010.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.010-Wild-Therapy-Ali-Bhtty.m4a",
        trackTime: "32:03"
      },
      {
        id: "7",
        songName: "Ep.009 Hard EDM & Rock",
        songimg: "../image/set/radioshow/009.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.009-Hard-EDM&Rock-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "8",
        songName: "Ep.008 Reggaeton 2021",
        songimg: "../image/set/radioshow/008.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "9",
        songName: "🅴 Ep.007 Altering Reality",
        songimg: "../image/set/radioshow/007.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.007-Altering-Reality-Ali-Bhtty.m4a",
        trackTime: "39:31"
      },
      {
        id: "10",
        songName: "Ep.006 YHLQMDLG Sesion",
        songimg: "../image/set/radioshow/006.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.006-YHLQMDLG-Bad-Bunny-Ali-Bhtty.m4a",
        trackTime: "34:31"
      },
      {
        id: "11",
        songName: "Ep.005 Salsatón",
        songimg: "../image/set/radioshow/005.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.005-Salsaton-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "12",
        songName: "Ep.004 ElectroPOP",
        songimg: "../image/set/radioshow/004.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.004-ElectroPOP-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "13",
        songName: "Ep.003 Progressive",
        songimg: "../image/set/radioshow/003.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.003-Progressive-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "14",
        songName: "🅴 Ep.002 Reggaeton Old School",
        songimg: "../image/set/radioshow/002.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.002-Reggaeton-Old-School-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "15",
        songName: "Ep.001 Dirty House",
        songimg: "../image/set/radioshow/001.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.001-Dirty-House-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "16",
        songName: "🅴 Ep.000 Bounce Drop",
        songimg: "../image/set/radioshow/000.jpg",
        songArtist: "Ali Bhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.000-Bounce-Drop-Ali-Bhtty.m4a",
        trackTime: "32:59"
      }
    ]
  },
  {
    id: "artist_knock2",
    type: "djs",
    title: "Knock2",
    artistLink: "knock2",
    playlistBg: "rgb(255, 102, 0)",
    imgUrl: "/image/djs/knock2/knock2.jpg",
    hoverColor: "rgb(255, 102, 0)",
    artist: "knock2",
    redSocial: "https://instagram.com",
    artistImgUrl: "../image/djs/knock2/knock2.jpg",
    artistBio: "radioshow",
    artistartistDownloadBio: "Descargar",
    club: "Zumba",
    clubtime: "06:30",
    endtime: "08:00",
    clubmapa: "Gran Vía de les Corts Catalanes 1080",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Rock Ur World (feat. fussy)",
        songimg: "../image/djs/knock2/room202.jpg",
        songArtist: "Knock2",
        link: "https://dl.dropbox.com/s/nvb50fsku1ytvf3/1-06%20Rock%20Ur%20World%20%28feat.%20fussy%29.m4a",
        trackTime: "04:41"
      }
    ]
  },
  {
    id: "artist_djromer",
    type: "djs",
    title: "DJ ROMER",
    artistLink: "djromer",
    featured: true,
    playlistBg: "rgb(90, 230, 97)",
    imgUrl: "/image/djs/djromer/djromer.jpg",
    hoverColor: "rgb(90, 230, 97)",
    artist: "djromer",
    redSocial: "https://instagram.com/romermusic.pe/",
    artistImgUrl: "../image/djs/djromer/djromer.jpg",
    artistBio: "NASA",
    artistartistDownloadBio: "Descargar",
    club: "Barza",
    clubtime: "22:30",
    endtime: "24:00",
    clubmapa: "Yurimaguas",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistImages: [
      "../image/djs/djromer/feed/01.jpg",
      "../image/djs/djromer/feed/02.jpg",
      "../image/djs/djromer/feed/03.jpg",
      "../image/djs/djromer/feed/04.jpg"
    ],
    playlistData: [
      {
        id: "1",
        songName: "🅴 THE ROOM LIVE 02",
        songimg: "../image/djs/djromer/sets/the-room-live-02.jpg",
        songArtist: "DJ ROMER",
        link: "https://changarrito.es/assets/mus/the-room-live-02.m4a",
        trackTime: "47:42"
      },
      {
        id: "2",
        songName: "THE ROOM LIVE 01",
        songimg: "../image/djs/djromer/sets/the-room-live-01.jpg",
        songArtist: "DJ ROMER",
        link: "https://changarrito.es/assets/mus/the-room-live-01.m4a",
        trackTime: "57:05"
      }
    ]
  },
  {
    id: "artist_cbrg",
    type: "djs",
    title: "CBRG",
    artistLink: "cyborg",
    featured: true,
    playlistBg: "rgb(64, 74, 173)",
    imgUrl: "/image/djs/cyborg/cyborg.jpg",
    hoverColor: "rgb(64, 74, 173)",
    artist: "cyborg",
    redSocial: "https://instagram.com",
    artistImgUrl: "../image/djs/cyborg/cyborg.jpg",
    artistBio: "radioshow",
    artistartistDownloadBio: "Descargar",
    club: "Zumba",
    clubtime: "06:30",
    endtime: "08:00",
    clubmapa: "Gran Vía de les Corts Catalanes 1080",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Kloud - VIRUS (Odd Mob Remix)",
        songimg: "../image/disco/virus.jpg",
        songArtist: "Kloud",
        link: "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
        trackTime: "4:25"
      },
      {
        id: "2",
        songName: "Nowhere (Odd Mob Remix)",
        songimg: "../image/disco/nowhere.jpg",
        songArtist: "Otosan",
        link: "https://dl.dropbox.com/s/qfbat76durimxuf/Otosan%20-%20Nowhere%20%28Odd%20Mob%20Remix%29.mp3?dl=1",
        trackTime: "4:25"
      },
      {
        id: "3",
        songName: "Right Now (Ali Bhtty Remix)",
        songimg: "../image/disco/right-now.jpg",
        songArtist: "Ali Bhtty ft. Wxlfgvng!",
        link: "https://dl.dropbox.com/s/rd2tfbwmr5dc1iv/Right%20Now%20-%20Wxlfgvng%20%28Ali%20Bhtty%20Remix%29.mp3?dl=1",
        trackTime: "3:15"
      }
    ]
  },
  {
    id: "artist_demotapes",
    type: "djs",
    title: "demotapes",
    artistLink: "demotapes",
    featured: true,
    playlistBg: "rgb(255, 171, 38)",
    imgUrl: "/image/djs/demotapes/demotapes.jpg",
    hoverColor: "rgb(255, 171, 38)",
    artist: "demotapes",
    redSocial: "https://instagram.com",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "top-urbano",
    artistartistDownloadBio: "Descargar",
    club: "Zumba",
    clubtime: "06:30",
    endtime: "08:00",
    clubmapa: "Gran Vía de les Corts Catalanes 1080",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "demotapes with friends mix",
        songimg: "../image/set/demotapes-bg.jpg",
        songArtist: "demotapes",
        link: "https://dl.dropbox.com/scl/fi/8qku4fxr8leiunvvwaxib/demotapes-with-friends-mix.m4a?rlkey=d9ho6sfoyy9ejq8apd0qaheo8&dl=1",
        trackTime: "19:56"
      }
    ]
  },
  {
    id: "artist_camoufly",
    type: "djs",
    title: "Camoufly",
    artistLink: "camoufly",
    featured: true,
    playlistBg: "rgb(155, 207, 153)",
    imgUrl: "/image/djs/camoufly/camoufly.jpg",
    hoverColor: "rgb(155, 207, 153)",
    artist: "camoufly",
    redSocial: "https://instagram.com",
    artistImgUrl: "../image/djs/camoufly/camoufly.jpg",
    artistBio: "top-urbano",
    artistartistDownloadBio: "Descargar",
    club: "Zumba",
    clubtime: "06:30",
    endtime: "08:00",
    clubmapa: "Gran Vía de les Corts Catalanes 1080",
    clubImg: "../image/djs/alibhtty/club/club.jpg",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Glittertape 8",
        songimg: "../image/set/glittertape.jpg",
        songArtist: "Camoufly",
        link: "https://dl.dropbox.com/scl/fi/txvrpznvxejs7bnlz96rs/glittertape-8.mp3?rlkey=w0irveeok4okv18z8z8u004q9&dl=1",
        trackTime: "29:42"
      }
    ]
  },
  {
    id: "artist_mixtape",
    type: "djs",
    title: "Mixtape®",
    artistLink: "mixtape",
    featured: true,
    playlistBg: "#07293d",
    imgUrl: "/image/djs/mixtape/mixtape.jpg",
    hoverColor: "#07293d",
    artist: "mixtape",
    redSocial: "https://instagram.com/mixtape.io",
    artistImgUrl: "../image/djs/mixtape/mixtape.png",
    artistBio: "New Era 🔥",
    artistartistDownloadBio: "Descargar",
    bannerUno: " ",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Glittertape 8",
        songimg: "../image/set/glittertape.jpg",
        songArtist: "Camoufly",
        link: "https://dl.dropbox.com/scl/fi/txvrpznvxejs7bnlz96rs/glittertape-8.mp3?rlkey=w0irveeok4okv18z8z8u004q9&dl=1",
        trackTime: "29:42"
      }
    ]
  }
];